// extracted by mini-css-extract-plugin
export default {"link":"Nav-link_link__crl1C","dark-link":"Nav-link_dark-link__eBKYK"};